export function wrapInPromise<T>(fn: () => T | Promise<T>): Promise<T> {
  try {
    return Promise.resolve(fn());
  } catch (err) {
    return Promise.reject(err);
  }
}

export const delay = <T>(millis: number, value?: T | Error): Promise<T> =>
  new Promise((resolve, reject) => {
    window.setTimeout(() => {
      if (value instanceof Error) {
        reject(value);
      } else {
        resolve(value);
      }
    }, millis);
  });

export type Deferred<TValue = void> = {
  promise: Promise<TValue>;
  resolve: (v?: TValue) => void;
  reject: (e?: any) => void;
};

export function createDeferred<TValue = void>(): Deferred<TValue> {
  let resolve!: Deferred<TValue>['resolve'];
  let reject!: Deferred<TValue>['reject'];

  const promise = new Promise<TValue>((res, rej) => {
    resolve = res;
    reject = rej;
  });

  return { promise, resolve, reject };
}
